import React from "react";
import styled from "styled-components";
// Components
import ProductBox from "../Elements/ProductBox";
// Assets
import ChavesAutomotivas from "../../assets/img/products/chaves-automotivas.png";
import ControleAlarme from "../../assets/img/products/controle-alarme.png";
import FechaduraTetra from "../../assets/img/products/fechadura-tetra.png";
import Fechaduras from "../../assets/img/products/fechaduras.png";
import FechadurasEletronicas from "../../assets/img/products/fechadura-eletronica.png";
import FechadurasPressao from "../../assets/img/products/fechadura-pressao-porta-pivotante.png";
import Cadeados from "../../assets/img/products/cadeados.png";
import Tags from "../../assets/img/products/tags.png";
import ControlesPortaoEletronico from "../../assets/img/products/controle-portao-eletronico.png";

export default function Products() {
  return (
    <Wrapper id="products">
      <div className="whiteBg">  
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold margin-bt-5">
              Produtos
            </h1>
            <p className="font15">
              Veja alguns de nossos principais produtos.
            </p>
          </HeaderInfo>
          <div className="row textCenter">
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProductBox
                img={ChavesAutomotivas}
                alt="Chaves Automotivas"   
                title="Chaves Automotivas"
                href="https://api.whatsapp.com/send?phone=5548991810053&text=Ol%C3%A1,%20gostaria%20de%20saber%20sobre%20as%20c%C3%B3pias%20de%20chaves%20automotivas!"
                target="_blank"          
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProductBox
                img={ControleAlarme}
                title="Controles Alarmes"
                alt="Controles Alarmes"
                href="https://api.whatsapp.com/send?phone=5548991810053&text=Ol%C3%A1,%20gostaria%20de%20saber%20sobre%20os%20controles%20de%20alarme!"
                target="_blank"                           
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProductBox
                img={ControlesPortaoEletronico}
                title="Controles portões eletrônicos"
                alt="Controles portões eletrônicos"
                href="https://api.whatsapp.com/send?phone=5548991810053&text=Ol%C3%A1,%20gostaria%20de%20saber%20sobre%20os%20controles%20para%20port%C3%B5es%20eletr%C3%B4nicos!"
                target="_blank"                              
              />
            </div>
          </div>
          <div className="row textCenter">
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProductBox
                img={Fechaduras}
                title="Fechaduras"
                alt="Fechaduras"
                href="https://api.whatsapp.com/send?phone=5548991810053&text=Ol%C3%A1,%20gostaria%20de%20saber%20sobre%20as%20fechaduras!"
                target="_blank"                              
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProductBox
                img={FechaduraTetra}
                title="Fechaduras Tetras"
                alt="Fechaduras Tetras"
                href="https://api.whatsapp.com/send?phone=5548991810053&text=Ol%C3%A1,%20gostaria%20de%20saber%20sobre%20as%20fechaduras%20tetras!"
                target="_blank"                         
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProductBox
                  img={FechadurasPressao}
                  title="Fechaduras de Pressão"
                  alt="Fechaduras de Pressão"
                  href="https://api.whatsapp.com/send?phone=5548991810053&text=Ol%C3%A1,%20gostaria%20de%20saber%20sobre%20fechaduras%20de%20press%C3%A3o"
                  target="_blank"                          
                />
            </div>
          </div>
          <div className="row textCenter">
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProductBox
                img={FechadurasEletronicas}
                title="Fechaduras eletrônicas"
                alt="Fechaduras eletrônicas"
                href="https://api.whatsapp.com/send?phone=5548991810053&text=Ol%C3%A1,%20gostaria%20de%20saber%20sobre%20as%20fechaduras%20eletr%C3%B4nicas!"
                target="_blank"                             
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProductBox
                img={Cadeados}
                title="Cadeados"
                alt="Cadeados"
                href="https://api.whatsapp.com/send?phone=5548991810053&text=Ol%C3%A1,%20gostaria%20de%20saber%20sobre%20os%20cadeados!"
                target="_blank"                           
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProductBox
                img={Tags}
                title="Tags"
                alt="Tags"
                href="https://api.whatsapp.com/send?phone=5548991810053&text=Ol%C3%A1,%20gostaria%20de%20saber%20sobre%20as%20tags!"
                target="_blank"                        
              />
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
`;
const HeaderInfo = styled.div`
  @media (max-width: 860px) {
    text-align: center;
  }
`;

